<template>
  <v-menu
    :value="show"
    :close-on-click="true"
    :close-on-content-click="false"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list>
      <template v-if="hasSelectedMessages">
        <v-list-item v-if="isSelected" @click="$emit('forwardMessage')" link>
          <v-list-item-icon class="mr-4">
            <v-icon style="transform: scale(-1, 1)">mdi-reply</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Переслать выбранные</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isSelected" @click="$emit('deleteMessages')" link>
          <v-list-item-icon class="mr-4">
            <v-btn
              v-if="loading"
              :loading="loading"
              plain
              icon
              class="pa-0 ma-0"
              style="line-height: 1; height: 24px; width: 24px"
            >
              <v-icon>mdi-cached</v-icon>
            </v-btn>
            <v-icon v-else>mdi-delete</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="danger--text">Удалить выбранные</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isSelected" @click="$emit('clearSelected')" link>
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="danger--text">Очистить выбранные</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!isSelected" @click="$emit('selectMessage')" link>
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="danger--text">Выбрать</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-else>
        <v-list-item>
          <v-list-item-content>
            <div class="colorpicker">
              <ul class="colorpicker__list">
                <li
                  v-for="color in colors"
                  v-bind:key="color"
                  class="colorpicker__list-item"
                >
                  <button
                    v-bind:key="color"
                    @click="() => $emit('selectColor', color)"
                    class="colorpicker__btn"
                    :class="[
                      color !== '' ? 'colorpicker__btn--' + color : '',
                      menuMessage && menuMessage.color === color
                        ? 'active'
                        : '',
                    ]"
                  ></button>
                </li>
              </ul>
            </div>
          </v-list-item-content>
        </v-list-item>

        <template v-if="isHistoryMessage">
          <v-list-item @click="$emit('commentMessage')" link>
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-comment-text-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Комментарий</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-else>
          <v-list-item v-if="showRatingButtons()" class="d-flex">
            <v-list-item-content>
              <div class="d-flex justify-space-between">
                <v-btn
                  @click="$emit('rateMessage', 'good')"
                  :color="menuMessage?.rating?.value === 'good' ? 'green' : ''"
                  elevation="0"
                  fab
                  small
                >
                  <v-icon>mdi-emoticon-happy-outline</v-icon>
                </v-btn>
                <v-btn
                  @click="$emit('rateMessage', 'bad')"
                  :color="menuMessage?.rating?.value === 'bad' ? 'red' : ''"
                  elevation="0"
                  fab
                  small
                >
                  <v-icon>mdi-emoticon-sad-outline</v-icon>
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('commentMessage')" link>
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-comment-text-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Комментарий</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('replyToMessage')" link>
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-reply</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Ответить</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('forwardMessage')" link>
            <v-list-item-icon class="mr-4">
              <v-icon style="transform: scale(-1, 1)">mdi-reply</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Переслать</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="menuMessage && menuMessage.supportId !== null"
            @click="$emit('editMessage')"
            link
          >
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Редактировать</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('deleteMessage')" :disabled="loading" link>
            <v-list-item-icon class="mr-4">
              <v-btn
                :loading="loading"
                icon
                class="pa-0 ma-0"
                style="line-height: 1; height: 24px; width: 24px"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span class="danger--text">Удалить</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('selectMessage')" link>
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span class="danger--text">Выбрать</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="menuMessage?.supportId === null"
            @click="$emit('getGptResponse')"
            link
            :disabled="gptResponseLoading"
          >
            <v-list-item-icon class="mr-4">
              <v-btn
                :loading="gptResponseLoading"
                icon
                class="pa-0 ma-0"
                style="line-height: 1; height: 24px; width: 24px"
              >
                <v-icon>mdi-assistant</v-icon>
              </v-btn>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span class="danger--text">GPT</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="$emit('copyMessageData')" link>
            <v-list-item-icon class="mr-4">
              <v-icon>mdi-bug</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span class="danger--text">debug data</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { HIGH_PRIVILEGE_SUPPORT_IDS } from '@/models/supports';

export default {
  name: 'MessageMenu',
  props: {
    show: Boolean,
    x: Number,
    y: Number,
    hasSelectedMessages: Boolean,
    isSelected: Boolean,
    isHistoryMessage: Boolean,
    menuMessage: Object,
    loading: Boolean,
    currentSupportAzureId: {
      type: String,
      required: false,
    },
    gptResponseLoading: Boolean,
  },

  data() {
    return {
      colors: ['', 'red', 'orange', 'green', 'blue'],
    };
  },

  methods: {
    showRatingButtons() {
      return (
        this.menuMessage?.supportId !== null &&
        HIGH_PRIVILEGE_SUPPORT_IDS.includes(this.currentSupportAzureId)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.colorpicker {
  &__list {
    display: flex;
    align-items: center;
    margin: -0.25rem;

    padding-left: 0;
    list-style: none;
  }

  &__list-item {
    line-height: 0;
    padding: 0.25rem;
  }

  &__btn {
    width: 0.75rem;
    height: 0.75rem;
    margin: 0.25rem;
    background: silver;
    border-radius: 999px;
    box-shadow: 0 0 0 4px rgba(192, 192, 192, 0.35);

    &:hover {
      opacity: 0.7;
    }

    &.active {
      background: transparent;
    }

    &--red {
      background: red;
      box-shadow: 0 0 0 4px rgba(255, 0, 0, 0.35);

      &.active {
        box-shadow: 0 0 0 4px rgba(255, 0, 0, 1);
      }
    }

    &--orange {
      background: orange;
      box-shadow: 0 0 0 4px rgba(255, 165, 0, 0.35);

      &.active {
        box-shadow: 0 0 0 4px rgba(255, 165, 0, 1);
      }
    }

    &--green {
      background: green;
      box-shadow: 0 0 0 4px rgba(0, 128, 0, 0.35);

      &.active {
        box-shadow: 0 0 0 4px rgba(0, 128, 0, 1);
      }
    }

    &--blue {
      background: blue;
      box-shadow: 0 0 0 4px rgba(0, 0, 255, 0.35);

      &.active {
        box-shadow: 0 0 0 4px rgba(0, 0, 255, 1);
      }
    }
  }
}
</style>
